import * as React from "react";
import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { OwnerPageInfo, ImageResource, ImageDetails } from "burde";
import { ApplicationState } from "store";
import { getOwnerPageImageResources } from "ui/store";
import { actionCreators, getOwnerPage } from "page/calendar/store";
import ZentaImagePickerV2 from "content/image/zenta-image-picker-v2";
import * as styles from "./owner-page-image-gallery.css";
import { useResources } from "contexts/resource-context";

type OwnerPageImageGalleryProps = {
    ownerPage: OwnerPageInfo;
    imageResources: Array<ImageResource>;
} & typeof actionCreators;

const OwnerPageImageGallery: React.FC<OwnerPageImageGalleryProps> = ({
    ownerPage,
    imageResources,
    updateOwnerPage,
}) => {
    const resources = useResources();
    const [selectedImage, setSelectedImage] = useState<ImageDetails | null>(
        null,
    );
    const [selectedTab, setSelectedTab] = useState<number>(0);

    useEffect(() => {
        if (ownerPage.imageId !== null && imageResources !== null) {
            const selectedImage = getSelectedImage(ownerPage.imageId);
            setSelectedImage(selectedImage);
            const selectedTab = getSelectedTab(ownerPage.imageId);
            setSelectedTab(selectedTab);
        }
    }, [imageResources]);

    useEffect(() => {
        if (ownerPage.customImageId !== null && ownerPage.imageId !== null) {
            const updatedOwnerPage = {
                ...ownerPage,
                imageId: null,
            };

            updateOwnerPage(updatedOwnerPage);
        }
    }, [ownerPage.customImageId]);

    useEffect(() => {
        if (ownerPage.imageId === null) {
            setSelectedImage(null);
        }
    }, [ownerPage.imageId]);

    const onSelectImage = (selectedImage: ImageDetails | null) => {
        setSelectedImage(selectedImage);
        // De-select image if already selected
        if (selectedImage !== null && ownerPage.imageId === selectedImage.id) {
            const updatedOwnerPage = {
                ...ownerPage,
                imageId: null,
                customImageId: null,
            };

            updateOwnerPage(updatedOwnerPage);
        } else {
            const updatedOwnerPage = {
                ...ownerPage,
                imageId: selectedImage ? selectedImage.id : null,
                customImageId: null,
            };
            updateOwnerPage(updatedOwnerPage);
        }
    };

    const getSelectedImage = (imageId: number) => {
        let selectedImage = null;

        if (imageResources !== null) {
            for (let i = 0; i < imageResources.length; i++) {
                for (let x = 0; x < imageResources[i].images.length; x++) {
                    if (imageResources[i].images[x].id == imageId) {
                        selectedImage = imageResources[i].images[x];
                        break;
                    }
                }
            }
        }
        return selectedImage;
    };

    const getSelectedTab = (imageId: number) => {
        let selectedTab = 0;

        if (imageResources !== null) {
            for (let i = 0; i < imageResources.length; i++) {
                for (let x = 0; x < imageResources[i].images.length; x++) {
                    if (imageResources[i].images[x].id == imageId) {
                        selectedTab = i;
                        break;
                    }
                }
            }
        }
        return selectedTab;
    };

    return (
        <>
            {imageResources && (
                <div>
                    <label className={styles.subLabel}>
                        {resources.Cover_Gallery}
                    </label>
                    <ul className={styles.tabGroup}>
                        {imageResources.map((item, index) => (
                            <li
                                key={item.resourceGroupTitle}
                                className={styles.tabGroupLi}>
                                <a
                                    className={`
                                            ${styles.categoryTabItem} ${
                                        index === selectedTab
                                            ? styles.categoryTabItemSelected
                                            : ""
                                    }`}
                                    onClick={() => setSelectedTab(index)}>
                                    {item.resourceGroupTitle}
                                </a>
                            </li>
                        ))}
                    </ul>
                    <ZentaImagePickerV2
                        selectedImage={
                            ownerPage.customImageId === null
                                ? selectedImage
                                : null
                        }
                        images={
                            imageResources[selectedTab] &&
                            imageResources[selectedTab].images
                                ? imageResources[selectedTab].images
                                : []
                        }
                        onClick={onSelectImage}
                    />
                </div>
            )}
        </>
    );
};

const mapStateToProps = (state: ApplicationState) => ({
    ownerPage: getOwnerPage(state),
    imageResources: getOwnerPageImageResources(state),
});

const mapDispatchToProps = {
    ...actionCreators,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(OwnerPageImageGallery);
